$(function () {
   
    // matchHeight
    function matchHeightText() {
        if($('.my26-summaryl1__bike-card-heading').length > 0){
            $('.my26-summaryl1__bike-card-heading').matchHeight({
                byRow: 0,
            });
        }
        if($('.my26-summary-bikes .my26-summaryl2__bike-info h5').length > 0){
            $('.my26-summary-bikes .my26-summaryl2__bike-info h5').matchHeight({
                byRow: 0,
            });
        }
        if($('.my26-summary-bikes .my26-summaryl2__bike-info p').length > 0){
            $('.my26-summary-bikes .my26-summaryl2__bike-info p').matchHeight({
                byRow: 0,
            });
        }
        if($('.my26-summary-non-motorized .my26-summaryl2__bike-info h5').length > 0){
            $('.my26-summary-non-motorized .my26-summaryl2__bike-info h5').matchHeight({
                byRow: 0,
            });
        }
        if($('.my26-summary-non-motorized .my26-summaryl2__bike-info p').length > 0){
            $('.my26-summary-non-motorized .my26-summaryl2__bike-info p').matchHeight({
                byRow: 0,
            });
        }
    }
    matchHeightText();
    // end matchHeight

    // bike summary detail slider
    function bikeSummarySetailSlider() {
        let $slider = $(".js-my26-summary-popup-slider");
        
        if ($slider.length > 0) {
            // Count the number of slides
            let slideCount = $slider.find('figure').length;
            
            console.log('Slide count:', slideCount); // Debug
            
            // Only initialize slider if there are 2 or more images
            if (slideCount > 1) {
                $slider.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    autoplay: false,
                    dots: true,
                    arrows: false,
                    draggable: true,
                });
                console.log('Slider initialized with multiple images');
            } else {
                // If only one image, just show it without slider
                $slider.addClass('single-image');
                console.log('Single image, no slider needed');
            }
        }
    }
    // end bike summary detail slider

    // bike summary detail scroll
    function bikeSummaryDetailScroll() {

        $('.my26-summary-popup.active-popup .my26-summary-popup__info-inner').on( "scroll", function() {

            let scrollTop = $(".my26-summary-popup.active-popup .my26-summary-popup__info-inner").offset().top;
            let $first;
            let firstPos;

            $('.my26-summary-popup.active-popup .product-info-list li').each(function() {

            let $box = $(this).removeClass('active-color');
            let pos = $box.offset();

            if(pos.top >= scrollTop && (!firstPos || pos.top < firstPos.top)){
                $first = $box;
                firstPos = pos;
            }
            });

            if($first){
                $first.addClass('active-color');   
            }
            
        });
    }
    // end bike summary detail scroll

    // // popup dynamic height get for custom scroll
    // function updateDynamicPopupHeight() {
    //     let sliderEl = $('.my26-summary-popup__left');
    //     let titleEl  = $('.my26-summary-popup__heading');
    //     let infoEl   = $('.my26-summary-popup__info-inner');

    //     let sliderH = sliderEl.length ? sliderEl.outerHeight() : 0;
    //     let titleH  = titleEl.length ? titleEl.outerHeight() : 0;

    //     let resultMaxHeight = $(window).height() - (sliderH + titleH + 100);

    //     if (infoEl.length) {
    //         infoEl.css('max-height', resultMaxHeight + 'px');
    //     }
    // }
    // // end popup dynamic height get for custom scroll

    // bike summary detail popup open/close
    $(document).on("click", ".js-bike-summary-detail", function () {

         if ($(this).hasClass("disable_click")) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return false;
        }
        let $card = $(this).closest('.my26-summaryl2__bike-card');
        
        // Get data from clicked card
        let bikeImage = $card.find('.my26-summaryl2__bike-card-img img').attr('src');
        let bikeTitle = $card.find('.my26-summaryl2__bike-info h5').text();
        let specificationsData = $card.find('.bike-specifications').val();
        let popupImagesData = $card.find('.bike-popup-images').val();
        
        console.log('Card Image:', bikeImage);
       
        console.log('Popup Images Data:', popupImagesData);
        
        // Update popup with clicked card data
        let $popup = $(".my26-summary-popup");
        
        // Destroy existing slider if initialized
        let $sliderSummaryPopup = $popup.find(".js-my26-summary-popup-slider");
        if ($sliderSummaryPopup.hasClass('slick-initialized')) {
            console.log('Destroying existing slider');
            $sliderSummaryPopup.slick('unslick');
        }
        
        // Remove single-image class if present
        $sliderSummaryPopup.removeClass('single-image');
        
        // Clear slider content
        $sliderSummaryPopup.empty();
        console.log('Slider cleared');
        
        // Check if we have popup images, otherwise use card image
        if (popupImagesData && popupImagesData.trim() !== '') {
            console.log('Using popup images from metaobject');
            let imageUrls = popupImagesData.split(',');
            console.log('Image URLs:', imageUrls);
            
            imageUrls.forEach(function(imageUrl, index) {
                if (imageUrl.trim() !== '') {
                    console.log('Adding image ' + (index + 1) + ':', imageUrl.trim());
                    $sliderSummaryPopup.append(`
                        <figure>
                            <img src="${imageUrl.trim()}" alt="${bikeTitle}" width="auto" height="auto">
                        </figure>
                    `);
                }
            });
        } else {
            console.log('No popup images found, using card image as fallback');
            // Fallback to card image if no popup images
            $sliderSummaryPopup.append(`
                <figure>
                    <img src="${bikeImage}" alt="${bikeTitle}" width="auto" height="auto">
                </figure>
            `);
        }
        
        console.log('Total figures added:', $sliderSummaryPopup.find('figure').length);
        
        // Update table with specifications
        let $popupInfo = $popup.find('.my26-summary-popup__info-inner');
        let $tableBody = $popupInfo.find('table tbody');
        $tableBody.empty();
        
        if (specificationsData) {
            try {
                let specifications = JSON.parse(specificationsData);
                console.log('Parsed Specifications:', specifications);
                
                if (specifications && specifications.length > 0) {
                    specifications.forEach(function(spec) {
                        $tableBody.append(`
                            <tr>
                                <th>${spec.label}</th>
                                <td>${spec.value}</td>
                            </tr>
                        `);
                    });
                } else {
                    $tableBody.append(`
                        <tr>
                            <td colspan="2" style="text-align: center; padding: 20px;">No specifications available</td>
                        </tr>
                    `);
                }
            } catch (e) {
                console.error('Error parsing specifications:', e);
                console.log('Raw data:', specificationsData);
                $tableBody.append(`
                    <tr>
                        <td colspan="2" style="text-align: center; padding: 20px;">Error loading specifications</td>
                    </tr>
                `);
            }
        } else {
            console.log('No specifications data found');
            $tableBody.append(`
                <tr>
                    <td colspan="2" style="text-align: center; padding: 20px;">No specifications available</td>
                </tr>
            `);
        }


        // geometry table
        // Update Geometry table
        let $geometryTableBody = $popupInfo.find('.geometry-table tbody');
        $geometryTableBody.empty();

        let geometryData = $card.find('.bike-geometry').val();

        if (geometryData) {
            try {
                // Decode HTML entities
                geometryData = geometryData.replace(/&quot;/g, '"').replace(/&amp;/g, '&');

                let geometryEntries = JSON.parse(geometryData); // Now you get proper array of objects
                if (geometryEntries.length > 0) {
                    geometryEntries.forEach(function(entry) {
                        $geometryTableBody.append(`
                            <tr>
                                <td>${entry.geo_name_1 || ''}</td>
                                <td>${entry.geo_name_2 || ''}</td>
                                <td>${entry.geo_name_3 || ''}</td>
                                <td>${entry.geo_name_4 || ''}</td>
                                <td>${entry.geo_name_5 || ''}</td>
                                <td>${entry.geo_name_6 || ''}</td>
                                <td>${entry.geo_name_7 || ''}</td>
                            </tr>
                        `);
                    });
                   // After building all rows, hide empty columns
                    let $table = $popupInfo.find('.geometry-table');
                    let $rows = $table.find('tbody tr');
                    let $headers = $table.find('thead th');

                    // RESET visibility first (important!)
                    $headers.show();
                    $rows.each(function() {
                        $(this).find("td").show();
                    });

                    // Loop through each column index
                    $headers.each(function(columnIndex) {
                        if (columnIndex === 0) return; // Skip GEO_NAME column

                        let isEmptyColumn = true;

                        // Check each row to see if column has any non-empty value
                        $rows.each(function() {
                            let cellText = $(this).find("td").eq(columnIndex).text().trim();
                            if (cellText !== "" && cellText !== "0") {
                                isEmptyColumn = false;
                                return false; // break loop
                            }
                        });

                        // If column is empty → hide header and each cell in that column
                        if (isEmptyColumn) {
                            $headers.eq(columnIndex).hide();
                            $rows.each(function() {
                                $(this).find("td").eq(columnIndex).hide();
                            });
                        }
                    });

                } else {
                    $geometryTableBody.append(`
                        <tr>
                            <td colspan="7" style="text-align: center; padding: 20px;">No geometry data available</td>
                        </tr>
                    `);
                }
            } catch(e) {
                console.error('Error parsing geometry data:', e);
                $geometryTableBody.append(`
                    <tr>
                        <td colspan="7" style="text-align: center; padding: 20px;">Error loading geometry</td>
                    </tr>
                `);
            }
        } else {
            $geometryTableBody.append(`
                <tr>
                    <td colspan="7" style="text-align: center; padding: 20px;">No geometry data available</td>
                </tr>
            `);
        }


        // color table start
        // Update Color table
            let $colorTableBody = $popupInfo.find('.color-table tbody');
            $colorTableBody.empty();

            let colorData = $card.find('.bike-colors').val();

            if (colorData) {
                try {
                    // Decode HTML entities
                    colorData = colorData.replace(/&quot;/g, '"').replace(/&amp;/g, '&');

                    let colorEntries = JSON.parse(colorData);

                    if (colorEntries.length > 0) {
                        colorEntries.forEach(function(entry) {
                            $colorTableBody.append(`
                                <tr>
                                    <th>
                                        <span class="color-swatch-dot" style="display:inline-block;width:16px;height:16px;border-radius:50%;background-color:${entry.color_code};vertical-align:middle;margin-right:6px;"></span>
                                        ${entry.color_code}
                                    </th>
                                    <td style="text-align: center;">${entry.color_name}</td>
                                </tr>
                            `);
                        });
                    } else {
                        $colorTableBody.append(`
                            <tr>
                                <td colspan="2" style="text-align: center; padding: 20px;">No color options available</td>
                            </tr>
                        `);
                    }
                } catch (e) {
                    console.error('Error parsing color data:', e);
                    $colorTableBody.append(`
                        <tr>
                            <td colspan="2" style="text-align: center; padding: 20px;">Error loading colors</td>
                        </tr>
                    `);
                }
            } else {
                $colorTableBody.append(`
                    <tr>
                        <td colspan="2" style="text-align: center; padding: 20px;">No color options available</td>
                    </tr>
                `);
            }


        // color table end

        
        // Show popup
        $card.addClass("is-open-popup");
        $("body").addClass("open-summary-popup");
        $popup.addClass("active-popup");
        
        // Initialize slider after popup is visible
        console.log('Initializing slider...');
        bikeSummarySetailSlider();
        bikeSummaryDetailScroll();
        
        if ($(window).width() <= 991) {
            setTimeout(() => {
                updateDynamicPopupHeight();
            }, 200);
        }
    });

    $(document).on("click", ".js-summary-popup-close", function () {
        console.log('Closing popup');
        $(".my26-summaryl2__bike-card").removeClass("is-open-popup");
        $("body").removeClass("open-summary-popup");
        $(".my26-summary-popup").removeClass("active-popup"); 

        let $sliderSummaryPopup = $(".js-my26-summary-popup-slider");
        if ($sliderSummaryPopup.hasClass('slick-initialized')) {
            console.log('Destroying slider on close');
            $sliderSummaryPopup.slick('unslick');
        }
        $sliderSummaryPopup.removeClass('single-image');
    });
    // end bike summary detail popup open

    // bike summary collapse - detail
    if ($(window).width() <= 991) {
        $('.js-summaryl2-category-title').click(function () {
            let $bikeSummaryCol = $(this).closest(".my26-summaryl2__bike-column");
            let $bikeSummaryWrap = $bikeSummaryCol.find('.my26-summaryl2__bike-wraper');

            if ($bikeSummaryCol.hasClass('is-column-active')) {
                $bikeSummaryWrap.stop(true, true).slideUp(300, "swing", function () {
                    $bikeSummaryCol.removeClass('is-column-active');
                });
            } else {
                $('.my26-summaryl2__bike-column.is-column-active').removeClass('is-column-active').find('.my26-summaryl2__bike-wraper').stop(true, true).slideUp(300, "swing");

                $bikeSummaryCol.addClass('is-column-active');
                $bikeSummaryWrap.stop(true, true).slideDown(300, "swing", function () {
                    $('html, body').animate({
                        scrollTop: $bikeSummaryCol.offset().top - 80
                    }, 400, "swing");
                });
            }
        });
    }
    // end bike summary collapse - detail

});